import { ComponentProps } from 'react';

import { Box, Flex, ForaDatePicker, Text, TooltipAriakit, useIsDeviceSize } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../i18n/i18n';

type EmploymentPeriodFormProps = {
  startDateInputProps: ComponentProps<typeof ForaDatePicker>;
  endDateInputProps: ComponentProps<typeof ForaDatePicker>;
  disabled?: boolean;
  ariaLabel?: string;
};

export const EmploymentPeriodForm = ({
  startDateInputProps,
  endDateInputProps,
  ariaLabel,
  disabled,
}: EmploymentPeriodFormProps) => {
  const { t } = useTypedTranslation();

  return (
    <Flex flexDirection={['column', 'row']} columnGap={40} rowGap={40}>
      {/*  TODO: Remove when the start date of the first employment period becomes editable. */}
      <TooltipAriakit
        id={'employment-period-form-tooltip'}
        variant="object"
        openOnHover={true}
        content={
          <Box>
            <Text fontWeight="bold">{t('tooltips.employment.markupStartDateLocked.title')} </Text>
            <Text>{t('tooltips.employment.markupStartDateLocked.description')} </Text>
          </Box>
        }
        conditionalTooltip={disabled}
      >
        <Box width={'100%'}>
          <ForaDatePicker
            {...startDateInputProps}
            label={t('common.startDate')}
            ariaLabel={ariaLabel}
            disabled={disabled}
            testId="start-date"
          />
        </Box>
      </TooltipAriakit>
      <Box width={'100%'}>
        <ForaDatePicker
          {...endDateInputProps}
          label={t('common.endDate')}
          useUntilFurtherNotice
          ariaLabel={ariaLabel}
          testId="end-date"
        />
      </Box>
    </Flex>
  );
};
